import type { WorkerAppointment } from "../types";
import { WorkerAppointmentCard } from "./worker-appointment-card";

interface WorkerAppointmentsCardListProps {
  appointments: WorkerAppointment[];
  showQuickActions?: boolean;
  onAppointmentClick?: (appointment: WorkerAppointment) => void;
}

export function WorkerAppointmentsCardList({
  appointments,
  showQuickActions = true,
  onAppointmentClick,
}: WorkerAppointmentsCardListProps) {
  if (appointments.length === 0) {
    return null;
  }

  return (
    <div className="block md:hidden space-y-3">
      {appointments.map((appointment) => (
        <WorkerAppointmentCard
          key={appointment.id}
          appointment={appointment}
          showQuickActions={showQuickActions}
          onAppointmentClick={onAppointmentClick}
        />
      ))}
    </div>
  );
}
